import styled from 'styled-components';
import { colors } from '../../../../../theme/colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow-y: auto;
  gap: 8px;
  width: 100%;
  height: calc(100vh - 300px);
  overflow-y: auto;
`;

const OneLiner = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const Meetings = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
`;

const Message = styled.div`
  font-size: 12px;
  color: ${colors.gray[500]};
`;

const Title = styled.div`
  width: 100%;
  font-family: 'Cera Pro';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.07px;
  text-transform: uppercase;
`;

export default {
  Container,
  OneLiner,
  Title,
  Meetings,
  Message,
};
